import React, { useState } from 'react';
import {
  Button,
  CircularProgress,
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import HistoryIcon from '@mui/icons-material/History';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import ThumbUpAltTwoToneIcon from '@mui/icons-material/ThumbUpAltTwoTone';
import ThumbDownAltTwoToneIcon from '@mui/icons-material/ThumbDownAltTwoTone';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import DrawIcon from '@mui/icons-material/Draw';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';

/**
 * Ações do card de atividades: primárias Autorizar/Negar + menu ⋯.
 */
export default function AtividadeRowActions({
  atividade,
  processoConcluido,
  isPendente,
  podeDecidir,
  processando,
  podeAssinaturas,
  assinaturaDocumentoId,
  documentoFinalUrl,
  isProcessoPagamento,
  onAutorizar,
  onNegar,
  onHistorico,
  onAbrirProcesso,
  onBaixarPdf,
  onEnviarAssinatura,
  onVerAssinatura,
}) {
  const [anchor, setAnchor] = useState(null);
  const fechar = () => setAnchor(null);
  const etapaAssinatura = /assinatura/i.test(
    `${atividade?.titulo || ''} ${atividade?.etapaNome || ''} ${atividade?.destinoLabel || ''}`
  );

  return (
    <Stack direction="row" spacing={0.5} alignItems="center" flexWrap="wrap" useFlexGap onClick={(e) => e.stopPropagation()}>
      {podeDecidir && isPendente && !processoConcluido && (
        <>
          <Button
            variant="contained"
            color="success"
            size="small"
            startIcon={processando ? <CircularProgress size={14} color="inherit" /> : <ThumbUpAltTwoToneIcon fontSize="small" />}
            disabled={processando}
            onClick={onAutorizar}
            sx={{ textTransform: 'none', borderRadius: 2 }}
          >
            Autorizar
          </Button>
          <Button
            variant="outlined"
            color="error"
            size="small"
            startIcon={<ThumbDownAltTwoToneIcon fontSize="small" />}
            disabled={processando}
            onClick={onNegar}
            sx={{ textTransform: 'none', borderRadius: 2 }}
          >
            Negar
          </Button>
        </>
      )}
      <Tooltip title="Mais ações">
        <IconButton size="small" onClick={(e) => setAnchor(e.currentTarget)}>
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchor}
        open={Boolean(anchor)}
        onClose={fechar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      >
        {!isProcessoPagamento && (
          <MenuItem
            onClick={() => {
              fechar();
              onHistorico();
            }}
          >
            <ListItemIcon>
              <HistoryIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Ver histórico</ListItemText>
          </MenuItem>
        )}
        {!isProcessoPagamento && atividade?.processoId && (
          <MenuItem
            onClick={() => {
              fechar();
              onAbrirProcesso();
            }}
          >
            <ListItemIcon>
              <OpenInNewIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Abrir processo</ListItemText>
          </MenuItem>
        )}
        {documentoFinalUrl && (
          <MenuItem
            onClick={() => {
              fechar();
              onBaixarPdf();
            }}
          >
            <ListItemIcon>
              <PictureAsPdfIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Baixar PDF consolidado</ListItemText>
          </MenuItem>
        )}
        {podeAssinaturas && assinaturaDocumentoId && (
          <MenuItem
            onClick={() => {
              fechar();
              onVerAssinatura();
            }}
          >
            <ListItemIcon>
              <DescriptionOutlinedIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Ver / continuar assinatura</ListItemText>
          </MenuItem>
        )}
        {podeAssinaturas && !isProcessoPagamento && !assinaturaDocumentoId && (etapaAssinatura || processoConcluido || documentoFinalUrl) && (
          <MenuItem
            onClick={() => {
              fechar();
              onEnviarAssinatura();
            }}
          >
            <ListItemIcon>
              <DrawIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Enviar para Assinatura</ListItemText>
          </MenuItem>
        )}
        {podeAssinaturas && isProcessoPagamento && atividade?.status === 'EM_ANDAMENTO' && (
          <MenuItem
            onClick={() => {
              fechar();
              onVerAssinatura();
            }}
          >
            <ListItemIcon>
              <DrawIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText>Continuar assinatura digital</ListItemText>
          </MenuItem>
        )}
      </Menu>
    </Stack>
  );
}
